import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';

const SlashCommandsPopover = ({
  showSuggestions,
  filteredCommands = [],
  selectedIndex,
  setSelectedIndex,
  applyCommand,
  suggestionsRef,
  isDark
}) => {
  if (!showSuggestions || filteredCommands.length === 0) return null;

  return (
    <div
      ref={suggestionsRef}
      className="position-absolute border rounded-3 shadow-lg p-1"
      style={{
        bottom: '100%',
        left: '16px',
        right: '16px',
        marginBottom: '8px',
        maxHeight: '230px',
        overflowY: 'auto',
        zIndex: 1050,
        backgroundColor: isDark ? '#182635' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <div
        className="px-2 py-1 d-flex align-items-center justify-content-between border-bottom mb-1"
        style={{
          fontSize: '0.72rem',
          borderColor: isDark ? '#233142' : '#e2e8f0',
          color: isDark ? '#94a3b8' : '#64748b'
        }}
      >
        <span className="d-flex align-items-center gap-1 fw-semibold text-success">
          <FontAwesomeIcon icon={faBolt} style={{ fontSize: '0.7rem' }} /> Atajos disponibles
        </span>
        <span style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
          Usa ↑ ↓ y pulsa <strong style={{ color: isDark ? '#e2e8f0' : '#1e293b' }}>Enter</strong> o <strong style={{ color: isDark ? '#e2e8f0' : '#1e293b' }}>Tab</strong>
        </span>
      </div>
      {filteredCommands.map((cmd, idx) => {
        const isSelected = idx === selectedIndex;
        return (
          <div
            key={cmd.command + idx}
            onClick={() => applyCommand(cmd)}
            onMouseEnter={() => setSelectedIndex(idx)}
            className="d-flex align-items-center justify-content-between p-2 rounded-2"
            style={{
              cursor: 'pointer',
              backgroundColor: isSelected
                ? (isDark ? 'rgba(16, 185, 129, 0.2)' : '#ecfdf5')
                : 'transparent',
              border: isSelected
                ? (isDark ? '1px solid rgba(16, 185, 129, 0.45)' : '1px solid #a7f3d0')
                : '1px solid transparent',
              transition: 'background-color 0.15s ease, border-color 0.15s ease'
            }}
          >
            <div className="d-flex align-items-center gap-2 overflow-hidden">
              <span
                style={{
                  fontFamily: 'monospace',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  borderRadius: '4px',
                  padding: '2px 6px',
                  backgroundColor: isSelected
                    ? (isDark ? 'rgba(16, 185, 129, 0.28)' : '#d1fae5')
                    : (isDark ? '#1e293b' : '#f1f5f9'),
                  color: isSelected
                    ? (isDark ? '#6ee7b7' : '#065f46')
                    : (isDark ? '#34d399' : '#059669'),
                  border: isSelected
                    ? (isDark ? '1px solid rgba(110, 231, 183, 0.5)' : '1px solid #6ee7b7')
                    : (isDark ? '1px solid #334155' : '1px solid #e2e8f0')
                }}
              >
                {cmd.command.startsWith('/') ? cmd.command : `/${cmd.command}`}
              </span>
              <div className="d-flex flex-column text-truncate">
                <span
                  style={{
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    color: isSelected
                      ? (isDark ? '#ffffff' : '#065f46')
                      : (isDark ? '#f1f5f9' : '#1e293b')
                  }}
                >
                  {cmd.title}
                </span>
                <small
                  className="text-truncate"
                  style={{
                    fontSize: '0.73rem',
                    maxWidth: '420px',
                    color: isSelected
                      ? (isDark ? '#cbd5e1' : '#047857')
                      : (isDark ? '#94a3b8' : '#64748b')
                  }}
                >
                  {cmd.text}
                </small>
              </div>
            </div>
            {isSelected && (
              <span
                style={{
                  fontSize: '0.68rem',
                  fontWeight: 600,
                  color: isDark ? '#6ee7b7' : '#065f46',
                  backgroundColor: isDark ? 'rgba(16, 185, 129, 0.25)' : '#d1fae5',
                  border: `1px solid ${isDark ? 'rgba(110, 231, 183, 0.45)' : '#6ee7b7'}`,
                  borderRadius: '4px',
                  padding: '2px 7px',
                  lineHeight: 1.3,
                  display: 'inline-flex',
                  alignItems: 'center',
                  userSelect: 'none'
                }}
              >
                Enter ↵
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

SlashCommandsPopover.propTypes = {
  showSuggestions: PropTypes.bool.isRequired,
  filteredCommands: PropTypes.array.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  applyCommand: PropTypes.func.isRequired,
  suggestionsRef: PropTypes.object.isRequired,
  isDark: PropTypes.bool
};

export default SlashCommandsPopover;
